import type { SettingsTabId } from './types';

export const SETTINGS_BASE_PATH = '/settings' as const;

export function settingsTabPath(tab: SettingsTabId): `${typeof SETTINGS_BASE_PATH}/${SettingsTabId}` {
    return `${SETTINGS_BASE_PATH}/${tab}`;
}
